import { Text, TextLink, MarkdownLite, Stack } from '@origin-digital/ods-core';
import { MouseEvent } from 'react';
import * as React from 'react';

interface OneTimeCodeFooterProps {
  onTryAnotherClicked: (event: MouseEvent<HTMLAnchorElement>) => void;
  hideTryAgainLink: boolean;
  emailOrMobileText: string;
}

const OneTimeCodeFooterView: React.FC<OneTimeCodeFooterProps> = ({
  hideTryAgainLink,
  emailOrMobileText,
  onTryAnotherClicked,
}) => {
  return (
    <Stack space="xsmall">
      {hideTryAgainLink ? (
        <>
          <Text data-id="footer-title" weight="medium">
            Not getting the code
          </Text>
          <Text data-id="footer-body">
            <MarkdownLite>[Get in touch](LIVECHAT) to change your details.</MarkdownLite>
          </Text>
        </>
      ) : (
        <>
          <Text data-id="footer-title" weight="medium">
            I'm still not getting the code
          </Text>
          <Text data-id="footer-body">
            Make sure you're using the contact details associated with your account.{' '}
            <TextLink data-id="try-another-link" href="#" onClick={onTryAnotherClicked}>
              Try another {emailOrMobileText}
            </TextLink>
            <MarkdownLite> or [get in touch](LIVECHAT) to change your details.</MarkdownLite>
          </Text>
        </>
      )}
    </Stack>
  );
};

export { OneTimeCodeFooterView };
